import Modal from '@/components/UI/Modal';
import BetterScroll from "../UI/BetterScroll";
export default {
  name: 'Rule',
  components: {
    Modal: Modal,
    BetterScroll: BetterScroll
  },
  settingKey: '规则',
  setting: {
    背景框: 'https://puui.qpic.cn/vupload/0/20190705_1562553642442_hv6s10ape5p.png/0',
    按钮: 'https://puui.qpic.cn/vupload/0/20190705_1562553558674_27616kfs3v1.png/0',
    标题: 'https://puui.qpic.cn/vupload/0/20190705_1562553628468_t573bzv6sxf.png/0',
    内容图: 'https://puui.qpic.cn/vupload/0/20190705_1562553829858_nzy108skgyk.png/0',
    详细规则: {
      type: 'text',
      default: '1. 等级越高<br>2. 大家'
    }
  },
  methods: {
    refreshBs: function refreshBs() {
      this.$refs.bs.refresh();
    }
  }
};